export default {
  "content": "<path d=\"M4.686 4.686a16 16 0 1022.628 22.628A16 16 0 004.686 4.686zM24.486 14a2 2 0 110 4H18v6.485a2 2 0 01-4 0V18H7.515a2 2 0 010-4H14V7.515a2 2 0 114 0V14h6.485z\" fill=\"#7083FF\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};